import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { mapSpecContract } from '@/common/config/contract';
import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { H2 } from '@/components/Typography/Typography';
import {
  selectSpecContractIsFail,
  selectSpecContractOpenDateByKind,
} from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { getTitles, rewards, styles } from './config';
import { ContractSubtitleWithReward } from './ContractSubtitleWithReward';

interface ContractSubtitleProps {
  kind: SpecContractType | PaidSpecContractType;
}

const ContractSubtitle: FC<ContractSubtitleProps> = ({ kind }) => {
  const openDate = useAppSelector((state) =>
    selectSpecContractOpenDateByKind(state, kind),
  );
  const contractIsFail = useAppSelector((state) =>
    selectSpecContractIsFail(state, kind),
  );
  const { t } = useTranslation();

  const reward = rewards[mapSpecContract[kind]];
  const title = getTitles(t)[mapSpecContract[kind]];
  const { withReward, withoutReward } = styles[mapSpecContract[kind]];

  return openDate ? (
    <ContractSubtitleWithReward
      reward={reward}
      className={cn(withReward, contractIsFail && 'opacity-50')}
    />
  ) : (
    <H2 weight="bold" className={withoutReward}>
      {title}
    </H2>
  );
};

export { ContractSubtitle };
